import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const called   = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    const code = new URLSearchParams(window.location.search).get('code');
    if (!code) { navigate('/'); return; }
    authAPI.handleCallback(code)
      .then(r => {
        localStorage.setItem('bce_token', r.data.token);
        navigate('/dashboard');
      })
      .catch(() => navigate('/'));
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div className="bce-spinner" style={{ width: 32, height: 32 }} />
      <p style={{ fontFamily: 'var(--font-condensed)', letterSpacing: '0.12em', color: 'var(--bce-text-faint)', textTransform: 'uppercase', fontSize: 13 }}>
        Authenticating...
      </p>
    </div>
  );
}
